module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rebate_intro right_auth"
  }, [_c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "left chain"
  }, [_vm._v("推荐注册链接："), _c('span', {
    attrs: {
      "id": "clip"
    }
  }, [_vm._v("http://www.sd235.net/reset/register.html?vcode=" + _vm._s(_vm.vcode))])]), _vm._v(" "), _c('button', {
    ref: "copy",
    attrs: {
      "data-clipboard-target": "#clip"
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制链接")]), _vm._v(" "), (_vm.wxCode) ? _c('img', {
    attrs: {
      "src": _vm.API.PRE + _vm.wxCode,
      "alt": "二维码"
    }
  }) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("推荐返利活动")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "title"
  }, [_vm._v("推荐返利规则")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', {
    staticClass: "flag"
  }, [_vm._v("注明：本规则会定期更新，本规则解释权归深度配音所有")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "content"
  }, [_c('li', [_vm._v("1.深度配音为促进老客户带动新客户的业务增长，即日起开展暂推荐返利活动！")]), _vm._v(" "), _c('li', [_vm._v("2.只要老客户使用平台专用的推荐注册链接，引导新客户注册，并产生业务，即可获取返利！")]), _vm._v(" "), _c('li', [_vm._v("3.多推荐多得，一级推荐和二级推荐都有返利，即A推荐B,B再推荐C,A也可从C的业务获取返利！")]), _vm._v(" "), _c('li', [_vm._v("4.具体规则细则见下。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "content"
  }, [_c('li', [_vm._v("1. 必须访问推荐人的推荐链接或二维码，并注册成功，才能参与返利。")]), _vm._v(" "), _c('li', [_vm._v("2. 推荐人是老用户推荐其他人成功交易，并且单笔订单利润大于零，即可获得被推荐人一定比例返利。")]), _vm._v(" "), _c('li', [_vm._v("3. 返利大于100元时可提现，提现请联系客服。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d956bbfe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/RebateIntro.vue
// module id = 872
// module chunks = 1